import { Component, OnInit } from '@angular/core';
import { NgForm, FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { AlertService } from 'src/app/data-services/alert.service';
import { UserService } from 'src/app/data-services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { first } from 'rxjs/operators';
import { PostService } from 'src/app/data-services/post.service';
import { ToastrService } from 'ngx-toastr';
import { MessageService } from 'src/app/data-services/message.service';
import {VoteQService} from 'src/app/data-services/vateQ.service';
import { HttpClient } from '@angular/common/http';
import {formatDate} from '@angular/common';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})

export class ProfileComponent implements OnInit {

  language = '';
  direction;
  defaultLanguage;
  form: FormGroup;
  postForm: FormGroup;
  FanvoteForm: FormGroup;
  commentForm: FormGroup;
  updatePostForm: FormGroup;
  submitted: boolean;
  errorFlag: boolean;
  loading: boolean;
  cloading: boolean;
  id: number;
  userId: number;
  profile: any = {};
  currentUser: any;
  posts:any;
  likes: number;
  comments: any;
  userData: any = [];
  public show: number;
  public buttonName: any = 'Show';
  selectPost: any = {};
  selectComment: any = {};
  visible: boolean;
  selectPostId: number;
  friends = [];
  selectedFile: File = null;
  imageName = '';
  videoName = '';
  today = new Date();
  votes:any;
  QA11:any;
  QA12:any;
  QA13:any;
  QTotal:any;
  QAll:any;
  currentDate = formatDate(Date.now(),'yyyy-MM-dd','en-US');
  currentDate2 = formatDate(Date.now(),'yyyy-MM-dd HH:mm:ss','en-US');

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private postService: PostService,
    private alertService: AlertService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private toastrService: ToastrService,
    private messageService: MessageService,
    private VoteQService:VoteQService,
    private http:HttpClient,
    public fb:FormBuilder
    ) {
    this.messageService.selectedLanguage.subscribe(res => {
      this.language = res.lang;
      this.direction = res.dir;
    });
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.userData = JSON.parse(localStorage.getItem('userData'));
  }
  ngOnInit() {

    this.defaultLanguage = JSON.parse(localStorage.getItem('language'));
    this.direction = this.defaultLanguage.dir;
    this.getMyFriends();
    this.loadAllPost();
    this.postForm = this.formBuilder.group({
      user_id: this.currentUser.success.user.id,
      content: [''],
      image: [''],
      video: [''],
      type: [''],
    });
    this.commentForm = this.formBuilder.group({
      content: ['', Validators.required],
      created_at :formatDate(Date.now(),'yyyy-MM-dd HH:mm:ss','en-US'),
      updated_at :formatDate(Date.now(),'yyyy-MM-dd HH:mm:ss','en-US'),
      post_id: '',
    });
    //this.http.get('http://127.0.0.1:8000/api/v1/getAllVoteQ').subscribe((result :any) =>{
    //  this.votes =result;
    //});
    this.loadAllQuestions();
    this.loadAllfansAnw();
    this.initForm(null);
  }
  loadAllQuestions() {
    const fangetdata = {
      user_id: this.currentUser.success.user.email,
    };
    this.VoteQService.getAllQA(fangetdata).pipe(first()).subscribe(
      fangetdata => {
        this.votes = fangetdata;
        for (const vote of this.votes) {
          // post.type = post.type.split('/')[0];
            //vote.VoteQ =vote.Qnumber;
            if(vote.Qstatus == 1)
            {
              this.FanvoteForm = this.fb.group({
                user_id: this.currentUser.success.user.email,
                QVA:[''],
                VoQuest:[vote.VoteQ],
                VoteNo:[vote.Qnumber],
                Votedate:formatDate(Date.now(),'yyyy-MM-dd','en-US')
              });
                var QA11:any = new FormData();
                  QA11.append('VQno', this.FanvoteForm.get('VoteNo').value);
                this.VoteQService.getAllQA1(QA11).subscribe(
                QA111=>{
                this.QA11 =QA111;
                });


                var QA12:any = new FormData();
                  QA12.append('VQno', this.FanvoteForm.get('VoteNo').value);
                this.VoteQService.getAllQA2(QA12).subscribe(
                QA112=>{
                  this.QA12 =QA112;
                });
                

                var QA13:any = new FormData();
                  QA13.append('VQno', this.FanvoteForm.get('VoteNo').value);
                this.VoteQService.getAllQA3(QA13).subscribe(
                QA113=>{
                this.QA13 =QA113;
                });

                var QAll:any = new FormData();
                QAll.append('VQno', this.FanvoteForm.get('VoteNo').value);
                this.VoteQService.getAllQAll(QAll).subscribe(
                  QAll=>{
                this.QAll =QAll;
                });
            }

        }
      }

    );
  }
  loadAllfansAnw() {
    const data = {
      user_id: this.currentUser.success.user.email,
    };
    this.VoteQService.getAllQA(data).pipe(first()).subscribe(
      votes => {
      this.votes = votes;
      for (const vote of this.votes) {
        // post.type = post.type.split('/')[0];
          //vote.VoteQ =vote.Qnumber;
          if(vote.Qstatus == 1)
          {
            
          }
  }});
  }
  setvotfan(){
    var fd1:any = new FormData();
    fd1.append('UserName', this.FanvoteForm.get('user_id').value);
    fd1.append('VoteQ', this.FanvoteForm.get('VoQuest').value);
    fd1.append('VoteA', this.FanvoteForm.get('QVA').value);
    fd1.append('VQno', this.FanvoteForm.get('VoteNo').value);
    fd1.append('VDate', this.FanvoteForm.get('Votedate').value);
    //this.http.post('http://127.0.0.1:8000/api/v1/votefans', fd1).subscribe(
      this.VoteQService.postQ(fd1).pipe(first()).subscribe(
      response => {
        this.toastrService.success('Thanks for share with us , Your voting is sended', 'Message!');
        this.visible = false;
        this.loading = false;
        this.errorFlag = false;
        this.submitted = true;
        this.loadAllQuestions();
      },
      error => {
        console.log(error);
        this.toastrService.error('Something went wrong Try again', 'Message!');
        this.visible = false;
        this.loading = false;
        this.errorFlag = false;
      }
    )
    
  }
  trackByFn(index, item) {
    return index; // or item.id
  }
  urlify(text: any) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function(url: string) {
        return `<a href="${url}" target="_blank" class="ddd">${url}</a>`;
      })
  }
  initForm(data: null) {
    this.updatePostForm = this.formBuilder.group({
      content: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(500)])],
      type: [''],
      image: [''],
      video: [''],
    });
  }

  onImageSelect(event) {
    const image = event.target.files[0];
    const type = event.target.files[0].type;
    if (type.match(/image\/*/) === null) {
      this.toastrService.error('Only Images are Supported', 'Message!');
      return;
    }
    this.imageName = event.target.files[0].name;
    this.postForm.get('type').setValue(type);
    this.postForm.get('image').setValue(image);

  }
  onVideoSelect(event) {
    const video = event.target.files[0];
    const type = event.target.files[0].type;
    if (type.match(/video\/*/) === null) {
      this.toastrService.error('Only Videos are Supported', 'Message!');
      return;
    }
    this.videoName = event.target.files[0].name;
    this.postForm.get('type').setValue(type);
    this.postForm.get('video').setValue(video);

  }

  /////////////////////////////////////// Posts Code
  get f() { return this.postForm.controls; }
  setPost() {
    this.submitted = true;
    this.errorFlag = false;
    this.loading = true;
    const fd = new FormData();
    fd.append('user_id', this.postForm.get('user_id').value);
    fd.append('content', this.postForm.get('content').value);
    fd.append('type', this.postForm.get('type').value);
    fd.append('image', this.postForm.get('image').value);
    fd.append('video', this.postForm.get('video').value);

    this.postService.post(fd).pipe(first()).subscribe(
      data => {
        this.toastrService.success('Your Post is Added', 'Message!');
        this.visible = false;
        this.loading = false;
        this.errorFlag = false;
        this.submitted = true;
        this.loadAllPost();
      },
      error => {
        console.log(error);
        this.toastrService.error('Something went wrong Try again', 'Message!');
        this.visible = false;
        this.loading = false;
        this.errorFlag = false;

      }
    );
    // this.postForm.reset();
    this.postForm = this.formBuilder.group({
      user_id: this.currentUser.success.user.id,
      content: [''],
      image: [''],
      video: [''],
      type: [''],
    });
    this.imageName = '';

  }


  loadAllPost() {
    const data = {
      user_id: this.currentUser.success.user.id,
    };
    this.postService.getAll(data).pipe(first()).subscribe(
      posts => {
        this.posts = posts;
        for (const post of this.posts) {
          // post.type = post.type.split('/')[0];
        }
      }

    );
  }
  

  deletePost(modal: any) {
    const data = {
      postId: this.selectPost.id,
    };
    this.postService.deletePost(data).subscribe(
      posts => {
        modal.hide();
        this.loadAllPost();
        this.toastrService.success('Post Deleted', 'Message!');
      },
      error => {
        console.log(error);
      }
    );
  }
  openDeleteModal(modal: any, post: any) {
    this.selectPost = post;
    modal.show();
  }
  openEditModal(modal: any, post: any) {
    this.selectPost = post;
    modal.show();
  }
  updatePost(modal: any) {
    const data = {
      id: this.selectPost.id,
      content: this.selectPost.content,
      image: this.selectPost.image,
    };
    this.postService.updatePost(data).subscribe(
      updatedPost => {
        this.toastrService.success('Post Updated', 'Message!');
        modal.hide();
      },
      error => {
        console.log(error);
      }
    );
  }

  closeEditModal(modal: any) {
    modal.hide();
    this.loadAllPost();
  }

  whoLikedMyPost(id: number) {
    const data = {
      post_id: id,
    };
    this.postService.whoLikedMyPost(data).pipe(first()).subscribe(likes => this.likes = likes[0]);

  }

  ///////////////////////////////////////// Comments Codes

  doComment(pId: number) {
    this.cloading = true;

    if (this.commentForm.valid === true) {
      this.commentForm.value.post_id = pId;
      this.commentForm.value.commenter_id = this.currentUser.success.user.id;
      this.postService.comment(this.commentForm.value).pipe(first()).subscribe(
        succuss => {
          this.toastrService.success('Comment Added', 'Message!');
          this.cloading = false;
          this.loadAllPost();
          this.showComments(pId);
        },
        error => {
          console.log(error);
          this.cloading = false;
        }
      );
    } else {
      this.toastrService.error('Invalid Form', 'Message!');
      this.cloading = false;
    }
    this.commentForm.reset();

  }

  openCommentDeleteModal(modal: any, comment: any, postId: number) {
    this.selectComment = comment;
    this.selectPostId = postId;
    modal.show();
  }

  deleteComment(modal: any, postId: number) {
    const data = {
      commentId: this.selectComment.commentId,
      post_id: this.selectPostId,
    };
    this.postService.deleteComment(data).subscribe(
      comments => {
        modal.hide();
        this.toastrService.success('Your Comment Deleted', 'Message!');
        this.showComments(postId);
      },
      error => {
        console.log(error);
      }
    );
  }

  toggle(Id: number) {
    if (this.show !== Id) {
      this.show = Id;
    } else {
      this.show = 0;
    }

    this.showComments(Id);

    if (this.show) {
      this.buttonName = 'Show';
    } else {
      this.buttonName = 'Hide';
    }

  }

  showComments(Id: number) {
    const data = {
      postId: Id,
    };
    this.postService.getAllComments(data).pipe(first()).subscribe(comments => this.comments = comments);

  }

  ///////////////////////////////////////// Likes Codes

  likeUnlike(id: number) {
    const data = {
      post_id: id,
      user_id: this.currentUser.success.user.id,

    };
    this.postService.likeUnlike(data).pipe(first()).subscribe(
      succuss => {
        this.loading = false;
        this.errorFlag = false;
        this.loadAllPost();
      },
      error => {
        console.log(error);
        this.loading = false;
        this.errorFlag = false;
      }
    );
  }

  /////////////////////////////////////// Friends

  getMyFriends() {
    const data = {
      user_id: this.currentUser.success.user.id,
    };
    this.userService.getFriends(data).pipe(first<any[]>()).subscribe(friends => this.friends = friends);
  }
  
  calculateDiff(sentDate) {
    var date1:any = new Date(sentDate);
    var date2:any = new Date();
    var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24 * 30 * 12));
    if(diffDays == 0)
    {
      var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24 * 30));
      if(diffDays == 0)
      {
        var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24 ));
        if(diffDays == 0)
        {
          var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60));
          if(diffDays == 0)
          {
            var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 ));
            if(diffDays == 0)
            {
              
            }
            else
            {
              return diffDays +" minutes ago";
            }
          }
          else
          {
            return diffDays +" hours ago";
          }
        }
        else
        {
          return diffDays +" day ago";
        }
      }
      return diffDays +" month ago";
    }
    else
    {
      return diffDays +" year ago";
    }
  }
  //votes = [
    //{
      //id:1,
      //VQuation:'Who is your Favorite Player?',
      //VA1:'Lionel Messi',
      //VA2:'Cristiano Ronaldo',
      //VA3:'Neymar Jr.',
      //VDate:'22/10/2025'
    //}
  //];
}
